import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LazyLoadImagesModule } from '@jfkz/ngx-lazy-load-images';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { BottomNavComponent } from './bottom-nav/bottom-nav.component';
import { SkolI18nPipe } from './core-services/pipes/i18n.pipe';
import { GamesDetailsComponent } from './game-details/games-details.component';
import { GamesResultsComponent } from './games-results/games-results.component';
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { PlayDemoBottomNavComponent } from './play-demo-bottom-nav/play-demo-bottom-nav.component';
import { SearchComponent } from './search/search.component';
import { SliderComponent } from './slider/slider.component';

export function AEHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    InlineSVGModule,
    BrowserModule,
    NgbModule,
    FontAwesomeModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    LazyLoadImagesModule,
    NgxSkeletonLoaderModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: AEHttpLoaderFactory,
        deps: [HttpClient],
      }
    }),
  ],
  declarations: [
    SkolI18nPipe,
    HeaderComponent,
    BottomNavComponent,
    GamesResultsComponent,
    SearchComponent,
    SliderComponent,
    PlayDemoBottomNavComponent,
    GamesDetailsComponent,
    MenuComponent,
  ],
  exports: [
    CommonModule,
    TranslateModule,
    HeaderComponent,
    SkolI18nPipe,
    InlineSVGModule,
    BrowserModule,
    NgbModule,
    FontAwesomeModule,
    NgxSkeletonLoaderModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    LazyLoadImagesModule,
    GamesResultsComponent,
    SearchComponent,
    SliderComponent,
    PlayDemoBottomNavComponent,
    BottomNavComponent,
    GamesDetailsComponent,
    MenuComponent,
  ],
  entryComponents: [
    HeaderComponent,
    GamesResultsComponent,
    SearchComponent,
    SliderComponent,
    PlayDemoBottomNavComponent,
    BottomNavComponent,
    GamesDetailsComponent,
    MenuComponent,
  ]
})
export class SharedComponentModule { }
